import { useState } from "react";
import { Navigate } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { useAuth } from "../../context/AuthContext";
import { OwnerOverview } from "./OwnerOverview";
import { OwnerAccounts } from "./OwnerAccounts";
import { OwnerPayments, OwnerSupport, OwnerAnnouncement } from "./OwnerTools";
import { FeedbackPanel } from "../AdminFeedback";

const TABS = [
  ["overview", "Overview", OwnerOverview], ["accounts", "Accounts", OwnerAccounts], ["payments", "Payments", OwnerPayments],
  ["support", "Support", OwnerSupport], ["feedback", "Leaver feedback", FeedbackPanel], ["announcement", "Announcement", OwnerAnnouncement],
];

export default function OwnerDashboard() {
  const { user } = useAuth();
  const [tab, setTab] = useState(() => new URLSearchParams(window.location.search).get("tab") || "overview");
  if (user && !user.is_owner) return <Navigate to="/dashboard" replace />;
  const Active = (TABS.find(([k]) => k === tab) || TABS[0])[2];
  const pick = (k) => { setTab(k); window.history.replaceState(null, "", `/owner?tab=${k}`); };
  return (
    <AppShell eyebrow="Owner" title="VizionCast HQ">
      <div className="flex overflow-x-auto border-b border-zinc-200 mb-6 -mx-1" data-testid="owner-tabs">
        {TABS.map(([k, label]) => (
          <button key={k} onClick={() => pick(k)} data-testid={`owner-tab-${k}`}
            className={`px-4 py-3 text-xs font-bold uppercase tracking-wider whitespace-nowrap border-b-2 -mb-px transition-colors ${tab === k ? "border-[#0033FF] text-zinc-900" : "border-transparent text-zinc-500 hover:text-zinc-900"}`}>
            {label}
          </button>
        ))}
      </div>
      <Active />
    </AppShell>
  );
}
